<template>
  <div>
    <mpHeader></mpHeader>
    <div class="indexView">
      <indexVideo></indexVideo>
      <div v-for="(item, index) in indexMsg" :key="index">
        <indexFont
          v-if="item.type === 'font'"
          :isTitle="item.isTitle"
          :title="item.title"
          :subTitle="item.sub_title"
          :itemId="item.id"
        ></indexFont>
        <indexImg
          v-else-if="item.type === 'img'"
          :src="item.src"
          :height="item.height"
          :subTitle="item.sub_title"
        ></indexImg>
        <indexFontAndImg
          v-else-if="item.type === 'left_and_right_context'"
          :isleftFont="item.isleftFont"
          :src="item.src"
          :title="item.title"
          :subTitle="item.sub_title"
        ></indexFontAndImg>
        <indexTab v-else-if="item.type === 'tab'"></indexTab>
        <indexImgList
          v-else-if="item.type === 'imgList'"
          :imgList="item.imgList"
        ></indexImgList>
        <indexUsersExample
          v-else-if="item.type === 'usersTab'"
        ></indexUsersExample>
      </div>
      <!-- <mpFooter></mpFooter> -->
    </div>
  </div>
</template>
<script>
import mpHeader from "@/components/mp-header/mp-header.vue";
import indexVideo from "./components/index-video.vue";
import indexFont from "./components/index-font.vue";
import indexImg from "./components/index-img.vue";
import indexFontAndImg from "./components/index-font-and-img.vue";
import indexTab from "./components/index-tab.vue";
import indexImgList from "./components/index-imgList.vue";
import indexUsersExample from "./components/index-users-example.vue";
// import mpFooter from "@/components/mp-footer/mp-footer.vue";

export default {
  components: {
    mpHeader,
    indexVideo,
    indexFont,
    indexImg,
    indexFontAndImg,
    indexTab,
    indexImgList,
    indexUsersExample
    // mpFooter,
  },
  data() {
    return {
      indexMsg: [
        {
          type: "font",
          title: "MPai数据科学平台",
          sub_title: "能够帮助每个人学会数据分析",
          isTitle: false,
          id: "product_introduction"
        },
        {
          type: "img",
          src: "../../../assets/icon-center.png",
          height: "10px"
        },
        {
          type: "font",
          title: "MPai定位是一款基础性数据分析软件",
          sub_title:
            "是为了解决人们想要快速上手并实践数据科学，同时兼顾工作效率的问题",
          isTitle: true,
          id: ""
        },
        {
          type: "left_and_right_context",
          isleftFont: true,
          title: "低门槛",
          sub_title:
            "一键自动化建模分析,从没涉及数据分析的小白也能在<span style='color:#28aae2'>5分钟内</span>熟练掌握。",
          src: "/introduce/img-introduce-001.png"
        },
        {
          type: "left_and_right_context",
          isleftFont: false,
          title: "一站式",
          sub_title:
            "一站式整合业界<span style='color:#28aae2'>95%+</span>的主流数据科学模型,算法模型应有尽有。",
          src: "/introduce/img-introduce-002.png"
        },
        {
          type: "left_and_right_context",
          isleftFont: true,
          title: "规范化",
          sub_title:
            "一键式结果呈现，结合结果模板分析，无需积累也能成为数据科学大神。每个功能配备分析步骤与智能分析，不需要自己阅读相关算法论文和进行模板完善或积累，极大地<span style='color:#28aae2'>减少重复性劳动</span>。",
          src: "/introduce/img-introduce-003.png"
        },
        {
          type: "left_and_right_context",
          isleftFont: false,
          title: "高效率",
          sub_title:
            "底层通过自研MPai核心计算引擎，实现了单机分布式与自适应分布式。对比业界平均水平最高可提升32倍的计算效率，同时使用单机网页端架构前端，浏览器输入MPai.go即可登录。",
          src: "/introduce/img-introduce-004.png"
        },
        {
          type: "left_and_right_context",
          isleftFont: true,
          title: "多协议数据导入",
          sub_title:
            "内置市面上绝大部分数据库驱动，多种协议接入数据。支持远程接入、关系型数据库、非关系型数据库，本地导入数据。规范化数据采集，无障碍对接数据科学项目。",
          src: "/introduce/img-introduce-005.png"
        },
        {
          type: "left_and_right_context",
          isleftFont: false,
          title: "集成可视化分析利器",
          sub_title:
            "拉入字段，字段生成图表生成的图表还能自由拼接导出为海报发布。",
          src: "/introduce/img-introduce-006.png"
        },
        {
          type: "font",
          title: "学习数据分析很难？",
          sub_title: "MPai让人们快速上手并实践数据科学，同时兼顾工作效率的问题",
          isTitle: true,
          id: "target_audience"
        },
        {
          type: "usersTab"
        },
        {
          type: "font",
          title: "在MPai掌握科学分析来进行辅助决策",
          sub_title: "MPai让人们快速上手并实践数据科学，同时兼顾工作效率的问题",
          isTitle: true,
          id: "customer_case"
        },
        {
          type: "tab"
        },
        {
          type: "font",
          title:
            "4.15亿数字岗位的首选数据分析工具<br>低门槛一站式数据科学的极致体验",
          sub_title: "",
          isTitle: true,
          id: "customer_domain"
        },
        {
          type: "font",
          title: "",
          sub_title:
            "我们的用户遍布互联网、腾讯、金融、咨询、零售快销、高校、政府、物流、地产等众多领域",
          isTitle: true
        },
        {
          type: "imgList",
          imgList: [
            "/domain/img-001.jpg",
            "/domain/img-002.jpg",
            "/domain/img-003.jpg",
            "/domain/img-004.jpg",
            "/domain/img-005.jpg",
            "/domain/img-006.jpg",
            "/domain/img-007.jpg",
            "/domain/img-008.jpg",
            "/domain/img-009.jpg",
            "/domain/img-010.jpg",
            "/domain/img-011.jpg",
            "/domain/img-012.jpg",
            "/domain/img-013.jpg",
            "/domain/img-014.jpg",
            "/domain/img-015.jpg",
            "/domain/img-016.jpg",
            "/domain/img-017.jpg",
            "/domain/img-018.jpg"
          ]
        }
      ]
    };
  }
};
</script>
<style scoped>
.indexView {
  position: relative;
  color: #000;
  /* width: 100vw; */
}
</style>
